import axios from 'axios';

export default function getClassroom(slug) {
  return axios.get(`/api/classrooms/${slug}`);
}
